var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightGray812 = function SvgArrowRightGray812(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F7070",
    fillRule: "evenodd",
    d: "M.987 11.418a.61.61 0 0 1 0-.88L5.655 6 .987 1.462a.61.61 0 0 1 0-.88.653.653 0 0 1 .906 0l5.12 4.978a.61.61 0 0 1 0 .88l-5.12 4.978a.653.653 0 0 1-.906 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRightGray812;